import api from './index';
const endpoints = {
    institutionStatus: '/admin/institution-status',
    approvalForm: '/approval-form',
    approvalDocuments: 'admin/approval-documents',
    institutions: 'admin/institutions',
};
export const getInstitutionStatus = async () => {
    const res = await api.get(endpoints.institutionStatus);
    return res.data.status;
};
export const getApprovalDocumentData = async (language = 'de') => {
    const res = await api.get(endpoints.approvalForm, { params: { lang: language } });
    return res.data;
};
export const sendApprovalDocuments = async ({ approvalMessage, file, }) => {
    const res = await api.post(endpoints.approvalDocuments, {
        approvalMessage,
        file,
    });
    return res.data;
};
export const getApprovalData = async (institutionId) => {
    const res = await api.get(`${endpoints.institutions}/${institutionId}/approval-documents/latest`);
    return res.data;
};
export const setInstitutionStatus = async ({ approved, id }) => {
    await api.patch(`${endpoints.approvalDocuments}/${id}`, { approved });
};
